export { App as default } from '@guiker/blog-main-mfe'
